import { useState, useEffect } from 'react';

interface CookieConsent {
  stamp: string;
  necessary: boolean;
  preferences: boolean;
  statistics: boolean;
  marketing: boolean;
  method: string;
}

interface CookiebotWindow extends Window {
  Cookiebot?: {
    consent: CookieConsent;
  };
}

interface UseCookieConsentReturn {
  statistics: boolean;
  method: string;
  allCookiesAccepted: boolean;
  consent: CookieConsent | null;
}

export const useCookieConsent = (): UseCookieConsentReturn => {
  const [consent, setConsent] = useState<CookieConsent | null>(null);

  useEffect(() => {
    const checkConsent = () => {
      const cookiebotWindow = window as CookiebotWindow;

      if (cookiebotWindow.Cookiebot?.consent) {
        setConsent(cookiebotWindow.Cookiebot.consent);
      }
    };

    // Check immediately
    checkConsent();

    // Listen for consent changes
    window.addEventListener('CookiebotOnAccept', checkConsent);
    window.addEventListener('CookiebotOnDecline', checkConsent);

    return () => {
      window.removeEventListener('CookiebotOnAccept', checkConsent);
      window.removeEventListener('CookiebotOnDecline', checkConsent);
    };
  }, []);

  const allCookiesAccepted = consent
    ? consent.necessary && consent.preferences && consent.statistics && consent.marketing
    : false;

  return {
    statistics: consent?.statistics ?? false,
    method: consent?.method ?? '',
    allCookiesAccepted,
    consent,
  };
};
